module.exports = __webpack_public_path__ + "static/img/12areaB_02.471c8d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_02.png
// module id = 1094
// module chunks = 1